module.exports = __webpack_public_path__ + "static/media/commodity-na.b183780d.svg";